export { default as MyAccount } from "./MyAccount.suite";
export { default as MyAccountContact } from "./MyAccountContact.suite";
export { default as MyAccountSecurity } from "./myAccountSecurity.suite";
export { default as MyAccountInformations } from "./myAccountInformations.suite";
